"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var tv4 = require('tv4');

var PersonReference = require('./person-reference');

var GroupReference = /*#__PURE__*/function () {
  function GroupReference(opt) {
    _classCallCheck(this, GroupReference);

    this.id = null;
    this.name = null;
    this.owner = null;

    if (opt) {
      this.fillObject(opt);
    }
  }

  _createClass(GroupReference, [{
    key: "fillObject",
    value: function fillObject(opt) {
      this.id = opt.id;
      this.name = opt.name;
      this.owner = new PersonReference(opt.owner);
    }
  }, {
    key: "validate",
    value: function validate() {
      return tv4.validateMultiple(this, GroupReference.schema());
    }
  }], [{
    key: "schema",
    value: function schema() {
      return {
        $schema: 'http://json-schema.org/draft-04/schema#',
        id: 'group-reference.schema.json',
        type: 'object',
        properties: {
          id: {
            type: 'string'
          },
          name: {
            type: 'string'
          },
          owner: {
            $ref: 'person-reference.schema.json'
          }
        },
        required: ['id', 'name', 'owner']
      };
    }
  }]);

  return GroupReference;
}();

tv4.addSchema(PersonReference.schema());
module.exports = GroupReference;